import PropertyRulesRedesign from './PropertyRulesRedesign';

export default PropertyRulesRedesign;
